module.exports = __webpack_public_path__ + "img/google-drive.9ba3b94a.svg";